/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {DLSTheme} from '../../types/types';

export interface ComponentProps {
  label: string;
  isRequired?: boolean;
}

const useStyles = makeStyles((theme: DLSTheme) => ({
  label : {
    color        : theme.dls.colors.grey2,
    marginBottom : '8px',
    ...theme.dls.typography.body3
  },
  requiredAsterisk : {
    color  : String(theme.dls.colors.aaBlue),
    margin : '0 2px'
  }
}));

/**
 * Displays a form field label matching those around the app.
 */
export const FieldLabel = ({label, isRequired = false}: ComponentProps) => {
  const classes = useStyles();
  return (
    <div className={classes.label}>
      {label}
      {isRequired && <span className={classes.requiredAsterisk}>*</span>}
    </div>
  );
};

export default FieldLabel;
